import PropTypes from "prop-types";

const ExternalLink = ({
  children = "Learn more",
  isTrackingAllowed = false,
  ...props
}) => (
  <a
    {...props}
    target="_blank"
    rel={isTrackingAllowed ? undefined : "noopener noreferrer"}
  >
    {children}
  </a>
);

ExternalLink.propTypes = {
  children: PropTypes.node.isRequired,
  isTrackingAllowed: PropTypes.bool,
};

export default ExternalLink;
